/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmModal } from '@cashfree-intl/coherent';

const DeleteModal = ({ onClose, deleteScheme }) => (
  <ConfirmModal
    danger
    title="Delete Scheme"
    onClose={onClose}
    onConfirm={deleteScheme}
    confirmText="Delete"
    confirmBtnEvent="Danger_Button_Delete_Scheme_Confirm"
    closeBtnEvent="Link_Button_Delete_Scheme_Cancel"
    closeCrossEvent="Delete_Scheme_Icon_Close"
  >
    All the transactions will be settled to merchant account instead of vendor.
    Are you sure you want to delete it?
  </ConfirmModal>
);

DeleteModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  deleteScheme: PropTypes.func.isRequired,
};

export default DeleteModal;
